import StickySidebar from 'app/utils/stickySidebar';
import { useTranslation } from 'next-i18next';
import BlogRightContent from './BlogLinks';
import { styleDom } from 'app/utils/dom';
import { useEffect } from 'react';
import "./styles.css";

export default function RightContent({ title = '', contentRight = null }: any) {
  const { t } = useTranslation();
  var stickySidebar: any = null;

  useEffect(() => {
    handleResizeMenuLeftRight();
    window.addEventListener("resize", handleResizeMenuLeftRight, { passive: true });

    return () => {
      if (stickySidebar) stickySidebar.destroy();
      window.removeEventListener("resize", handleResizeMenuLeftRight);
    }
  }, []);

  const handleResizeMenuLeftRight = () => {
    const SIZEBAR_WIDTH = 260;
    const MENU_RIGHT_WIDTH = 300;
    const documentWidth = window.innerWidth < 1500 ? window.innerWidth : 1500;
    let contentWidth = `${documentWidth - SIZEBAR_WIDTH - MENU_RIGHT_WIDTH}px`;
    if (window.innerWidth <= 991) {
      contentWidth = '100%';
    }

    styleDom('.box-news-area', 'minHeight', `${window.innerHeight}px`);
    styleDom('.box-news-area', 'minWidth', contentWidth);
    styleDom('.box-news-area', 'maxWidth', contentWidth);
    styleDom('#rightContent .content', 'maxHeight', `${window.innerHeight}px`);
    styleDom('.full-width', 'minWidth', `${documentWidth - SIZEBAR_WIDTH}px`);

    setSticketContentRight();
  }

  const setSticketContentRight = () => {
    setTimeout(() => {
      if (stickySidebar) stickySidebar.destroy();
      const rightContent = document.getElementById('rightContent');
      if (!rightContent) return;
      stickySidebar = new StickySidebar('#rightContent', {
        topSpacing: 70,
      })
    }, 0)
  }

  return (
    <div id="rightContent" style={{ width: 300 }}>
      <div className="py-3">
        <div className="mb-2">
          <label className="title text-center text-capitalize text-info">
            {title || t('news.title')}
          </label>
        </div>
        <div className="content px-2">
          <BlogRightContent title={title} contentRight={contentRight}/>
        </div>
      </div>
    </div>
  )
}
